import React from "react";
import { useLoadingMain, useQuery, useResults } from "~assets/frontend/frame/frm-search/store/SearchStore";
import { SearchAds } from "~assets/frontend/frame/frm-search/components/SearchAds";
import { SearchFacets } from "~assets/frontend/frame/frm-search/components/SearchFacets";
import { Loading } from "~assets/frontend/frame/frm-search/components/Loading";
import Translator from "bazinga-translator";
window.Translator = Translator;
export const SearchBody = () => {
    var _a;
    const query = useQuery();
    const results = useResults();
    const loadingMain = useLoadingMain();
    const totalResults = (_a = results === null || results === void 0 ? void 0 : results.facets.reduce((sum, facet) => sum + facet.total, 0)) !== null && _a !== void 0 ? _a : 0;
    if (query === null || query.length === 0) {
        return null;
    }
    let noResultsString = null;
    if ((results === null || results === void 0 ? void 0 : results.facets) && totalResults <= 0) {
        noResultsString = [React.createElement("p", null, Translator.trans("frm-search.no-results.line1", { query }, "frontend"))];
        const line2 = Translator.trans("frm-search.no-results.line2", { query }, "frontend");
        if (line2 !== "frm-search.no-results.line2" && line2 !== "") {
            noResultsString.push(React.createElement("p", { className: "pt-12" }, line2));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container mx-auto mb-96 pb-96 pt-24 xl:pt-12" },
            React.createElement("div", { className: "grid grid-cols-1 lg:grid-cols-3" },
                React.createElement("div", { className: "lg:col-span-2 lg:col-start-2" },
                    loadingMain && React.createElement(Loading, { label: Translator.trans("frm-search.searching-for", { query: loadingMain }, "frontend") }),
                    (results === null || results === void 0 ? void 0 : results.searchAds) && React.createElement(SearchAds, { searchAds: results.searchAds }),
                    (results === null || results === void 0 ? void 0 : results.facets) && totalResults > 0 && React.createElement(SearchFacets, { facets: results.facets }),
                    noResultsString)))));
};
